export class UserLoginVM {
    username:string='';
    password:string='';
}

export class KRAVM{
 EmployeeID:string='';
 AllocationPercent:  number=100;
 BufferPercent:  number=100;
 EmployeeName: string='';
 ProcessName: string='';
 ReportingOfficerID1: string='';
 ReportingOfficerID2: string='';
 Shift: string='';
 SubTeamName: string='';
 TeamName: string='';
 mapping_id:  number=100;
 
}

export class EmployeeTeamVM{
AllocationPercent: number=100;
BufferPercent: number=0;
TeamName: string='NA';
ProcessName: string='NA';
ProcessCount: string='NA';
FTE:number=0.0;
ALLFTEBuffer:number=0.0;
ALLFTEAllocation:number=0.0;
Total:number=0;
Team: string='';
ALL:number=0.0;
ARFTEBuffer:number=0.0;
ARFTEAllocation:number=0.0;
AR:number=0.0;
Coding:number=0.0;
CodingFTEBuffer:number=0.0;
CodingFTEAllocation:number=0.0;
CP:number=0.0;
CPFTEBuffer:number=0.0;
CPFTEAllocation:number=0.0;

Demo:number=0.0;
DemoFTEBuffer:number=0.0;
DemoFTEAllocation:number=0.0;

Denials:number=0.0;
DenialsFTEBuffer:number=0.0;
DenialsFTEAllocation:number=0.0;

PFS:number=0.0;
PFSFTEBuffer:number=0.0;
PFSFTEAllocation:number=0.0;

NA:number=0.0;
NAFTEBuffer:number=0.0;
NAFTEAllocation:number=0.0;

PP:number=0.0;
PPFTEBuffer:number=0.0;
PPFTEAllocation:number=0.0;

Statements:number=0.0;
StatementsFTEBuffer:number=0.0;
StatementsFTEAllocation:number=0.0;

Credentialing:number=0.0;
CredentialingFTEBuffer:number=0.0;
CredentialingFTEAllocation:number=0.0;

Other:number=0.0;
OtherFTEBuffer:number=0.0;
OtherFTEAllocation:number=0.0;

TotalHCFTEAllocation:number=0.0;
TotalHCFTEBuffer:number=0.0;
TotalHC:number=0.0;

EmployeeOfficeBadgeId: string = "";
EmployeeName: string = "";
SubTeamName: string='NA';
EmployeeID: string='';
EGID: number=0;
team: string='';
count: string='';
type:string='';
mapping_id:number=0;
Processes:string='';
Department:string='';
Branch:string='';
// ___

OfficeLocation:string='';
Shift:string='';
ReportingOfficerID1:string='';
ReportingOfficerID2:string='';

}
export class EmployeeAttritionDataVM{
    EmployeeId:string= "";
    EmployeeName: string="";
    EmploymentType:string= "";
    Gender:string= "";
    Designation:string= "";
    Department:string= "";
    Date_of_Exit:string=""
   OfficeLocation:string= "";
   Branch:string= "";
   EmployeeRole: string="";
   PrimaryReportingOfficer:string= "";
   SecondaryReportingOfficer:string= ""
   Reporting3:string= "" 
   Reporting4:string= "" 
   Reporting5:string= "" 
   Reporting6:string= "" 
   Reporting7:string= "" 

 
}


export class EmployeeDataVM{
    EmployeeID:string='';
    EmployeeName:string='';
    LookUpName:string='';
    AllocationPercent:number=0;
    BufferPercent:number=0;
    Shift:string='';
    ReportingOfficerID1:string='';
    ReportingOfficerID2:string='';
    Branch:string='';
    Department:string='';
    Designation:string='';
    }

export class AuditTrialVM{
    EmployeeOfficeBadgeId:string='';
    FieldName:string='';
    PreviousValue:string='';
    NewValue:string='';
    UpdatedBy:string='';
    UpdatedOn:string='';
   // updatedOn:string='';
}

export class AuditPropVM{
    
    OldDesig: any;
    newDesig: any;
}

export class EmployeeKRAVM{
    KRA1:number=0;
    KRA2:number=0;
    KRA3:number=0;
    KRA4:number=0;
    KRA5:number=0;
    KRATotalScore:number=0;
    ReviewMonth:number=0;
    ReviewYear:number=0;
    }
    export class  AttendanceVM{
        AttendanceMonth: string='';
        }
    export class  EmployeeRecordsVM{
        EmployeeOfficeBadgeId:string='';
        FullName:string='';
        EmploymentType: string='';
        Gender: string='';
        branch: string='';
        Department: string='';
        EmployeeDesignation: string='';
        OfficeLocation: string='';
        PrimaryReportingOfficer: string='';
        SecondaryReportingOfficer: string='';
        WorkShift: string='';
        EmployeeEmail: string='';
        EmployeeRole: string='';
        XliteExtensionNumber:string='';
        Tenurity_in_Project: string='';
        RCMTenurity: string='';
        ProductionRole:string='';
        WorkStationNumber: string='';
        Ramp_up_state: string='';
        Doj:String='';
    }

export class AccountsVM{
    AccountID:number=0;
    AccountName:string='';
    AccountCode:string='';
    VCAccountRefID:number=0;
    IsActive:string='';
    EndDate:string='';
    CreatedBy:string='';
    ModifiedBy:string='';  
    IsNonVC:string='';
}

export class ProcessesVM{
    ProcessID:number=0;
    ProcessName:string='';
    ProcessCode:string='';
    IsActive:string='';
    EndDate:string='';
    CreatedBy:string='';
    ModifiedBy:string='';
}

export class SubStateVM{
    SubStateId:number=0;
    SubStateName:string='';
    ProcessName:string='';
    CaseType:string='';
    VCFromState:string='';
    VCToState:string='';
    Status:string='';
    Payer:string='';
    Action:string='';
    CreatedBy:string='';
    ModifiedBy:string='';

}

export class WeightageVM{
    WeightageID:number=0;
    AccountName:string='NA';
    ProcessName:string='';
    SubStateName:string='';
    Target1:number=0.0;
    Target2:number=0.0;
    Target3:number=0.0;
    status:string='';
    AccountID:number=0;
    ProcessID:number=0;
    SubStateID:number=0;
}

export class ApprovalVM{
    ID:number=0;
    EmployeeID:string='';
    FullName:string='';
    Designation:string='';
    Date:string='';
    AccountName:string='';
    ProcessName:string='';
    SubStateName:string='';
    ProductionCount:number=0;
    Remarks:string='';
    ProductionPercent:number=0;
    status:string='';
    ApprovedBy:string='';
    ApprovedOn:string='';
    status1:string='';
    SubmittedOn: string='';
   
}

export class KRADataVM{
    EmployeeOfficeBadgeId:string='' ;
    Payer:string='' ;
    Action:string='' ;
    Shift:string='';
    Date:number=0;
    ReportingOfficer:string='';
    Designation:string='';
    AccountName:string='';
    ProcessName:string='';
    SubStateName:string='';
    ProductionCount:number = 0;
    ProductionRating:number=0;
    Productionpercent:number=0.0;
    status:string='';
    Remarks:string='';
    SubmittedOn:string=''
    ApprovedBy:string=''
    ApprovedOn:string=''
    CaseType:string=''
    ProductionTarget:number=0.0;
    Year:string='';
    TotalProductionCount:number=0;
    KRAID:number=0;
    Rating:number=0.0;
    BaseAttendance:number=0;
    EligibleAttendance:number=0;
    LOP:number=0;
    ApprovedLeave:number=0;
    FullPresent:number=0;


}

export class ProductivityReportVM
{
    EmployeeOfficeBadgeId:string='';
    EmployeeName:string='';
    Designation:string='';
    Lead:string='';
    Totalproduction:number=0;
    MTDProduction:number=0;
    WorkingDays:number=0;
    SubmittedOn:string='';
    TotalProductionPercent:number=0;
}
export class PKTVM
{
    EmployeeOfficeBadgeId:string='';
    ID:number=0;
    State:string='';
    StartedOn:string='';
    CompletedOn:string='';
    Percentage:number=0.0;
    Total:number=0;
    Grade:number=0;
}
export class FeedBackVM
{
    EmployeeOfficeBadgeId:string='';
    ID:number=0;
    Name:string='';
    Designation:string='';
    FeedBack:number=0.5;
    FeedBackYear:string='';
    FeedBackYear1:string='';

    UpdatedBy:string='';
    Comments:string=" ";
}
export class QualityVM
{
    EmployeeOfficeBadgeId:string='';
    ID:number=0;
    SumOfAuditCount:number=0;

    SumOfWeightedDefectiveCount:number=0.0;
    QualityPercent:number=0.0;
    Month:string='';
}
export class OverallKRA
{
    EmployeeName:string='';
    QualityPercent:number=0;
    WorkingDays:number=0;
    Feedback:number=0.0;
    ProductionCount:number=0.0;
    FullPresent:number=0.0;
    Percentage:number=0.0;
}

export class LabelValueVM
{
    label:string='';
    value:string='';
}

export class IPValueVM
{
    uname:string='';
    ipaddress:string='';
}

    export class IdeaPortalVM{
        IdeaDetailID:number=0;
        IdeaType:string='';
        IdeaTitle:string='';
        IdeaDescription:string='';
        Status:string='';
        ReviewedBy:string='';
        IsAnonymous:boolean=false;
        CreatedBy:string='';
        Comments:string='';
        file: string='' ;
        IdeaDetailNumber: string = '';
        CreatedDate: string = '';
        FilePath: string = '';
        ApprovedDate: string = '';
        RejectedDate: string = '';
        SequenceNumber:number=0;
        FileName:string='';

    }